import React from 'react';
import { Box, Dialog, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Oval } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

import { getLocalizedContent as l } from '@helpers/languages';
import content from './PaymentProcessingModal.json';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'SchnyderSLight',
  },
}));

export const PaymentProcessingModal = ({ open, amountChargedString }) => {
  const classes = useStyles();
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <Box paddingY={6} paddingX={2}>
        <Grid container spacing={4}>
          <Grid item xs={12} container justifyContent="center">
            <Typography variant="h4" className={classes.title}>
              {l(content.process, language)}
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Typography variant="body1" data-payment-processing-amount-charged>
              {l(content.charged, language)}
              {amountChargedString}
            </Typography>
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12} container justifyContent="center">
            <Oval color="#9d857f" height={48} width={48} />
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
